// ABOUTME: Smart wrapper for the Order Intake Lead Time entity — owns useOrderIntakeLeadTimeEntity and reports state via context.
// ABOUTME: Renders skeleton/error/form so the page no longer branches per entity.
import React from 'react'

import {useOrderIntakeLeadTimeEntity} from '../hooks/useOrderIntakeLeadTimeEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'
import {OrderIntakeLeadTimeForm} from './OrderIntakeLeadTimeForm'

export const OrderIntakeLeadTimeEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, error, isSaving, actions, nonBusinessDays} = useOrderIntakeLeadTimeEntity({
    countryId: ctx.countryId,
    businessLine: ctx.businessLine,
    scopeId: ctx.selectedScopeId,
    pendingScope: ctx.pendingScope,
    rootScopeId: ctx.rootScopeId,
  })

  useRegisterEntityForm(actions, isSaving)

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <OrderIntakeLeadTimeForm
      key={`order-intake-lead-time-${ctx.selectedScopeId ?? 'none'}-${ctx.formResetKey}`}
      config={config}
      isReadOnly={ctx.isReadOnly}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
      distanceUomOptions={ctx.leadTimeDistanceUomOptions ?? config.distanceUomOptions}
      leadTimeOptions={ctx.leadTimeFormOptions}
      nonBusinessDays={nonBusinessDays}
    />
  )
}
